import { LegacyDataTable, LegacyDataTableBody, LegacyDataTableHeader } from "@octopusdeploy/design-system-components";
import type { ReactNode } from "react";
import type React from "react";
import { Note } from "~/components/form";
import styles from "./styles.module.less";
interface Props {
    title?: string;
    isEmpty: boolean;
    note: ReactNode;
    headerContent: ReactNode;
    bodyContent: React.ReactNode;
}
export function TrendTable({ title, headerContent, bodyContent, isEmpty, note }: Props) {
    return (<div className={styles.container}>
            <div className={styles.sectionHeading}>
                <h2 className={styles.title}>{title}</h2>
            </div>
            <div className={styles.contentContainer}>
                {isEmpty ? (<span className={styles.nothingToShow}>Nothing to show</span>) : (<LegacyDataTable>
                        <LegacyDataTableHeader>{headerContent}</LegacyDataTableHeader>
                        <LegacyDataTableBody>{bodyContent}</LegacyDataTableBody>
                    </LegacyDataTable>)}
            </div>
            <div className={styles.contentContainer}>
                <Note>{note}</Note>
            </div>
        </div>);
}
